<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'gestoesDeAulas',
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Plano Bimestral Infantil
        </h1>
      </v-col>
    </v-row>

    <div v-if="turmaSemCircuito">
      <v-alert
        type="warning"
        border="left"
        colored-border
        elevation="2"
        icon="mdi-alert-circle-outline"
        dense
        class="mt-4"
      >
        Não é possível enviar planos bimestrais: não há circuito cadastrado para esta turma.
      </v-alert>
    </div>

    <div v-else>
      <v-row>
        <v-col cols="12" v-if="gestaoDeAula">
          <v-card color="green lighten-1" outlined>
            <v-col cols="10">
              <v-card-text>
                <h4>Turma: {{ gestaoDeAula.turma.descricao }}</h4>
                <h4>Disciplina: {{ gestaoDeAula.disciplina.descricao }}</h4>
                <h4>
                  Professor:
                  {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[carregando...]" }}
                </h4>
              </v-card-text>
            </v-col>

            <v-col cols="2">
              <v-btn
                x-small
                class="ml-1 white--text"
                color="teal darken-2"
                @click="() => verHistoricoPlanos()"
              >
                <span>Histórico do lançamento de planos</span>
              </v-btn>
            </v-col>
            <v-col cols="2">
              <v-btn
                large
                class="ml-1 white--text"
                color="teal darken-4"
                @click="() => baixarDocumentoPlanoAnualInfantil()"
              >
                <v-icon class="mr-2">fa fa-download</v-icon>
                <span>Documento Auxiliar</span>
              </v-btn>
            </v-col>
          </v-card>
        </v-col>

        <v-col cols="12" class="pt-2">
          <template>
            <v-toolbar>
              <v-tabs dark background-color="primary" v-model="tabIndexEtapas" grow>
                <v-tab
                  v-for="(value, desc) in etapas"
                  :key="parseInt(value, 10)"
                  @click="() => loadData(parseInt(value, 10))"
                >
                  <v-badge v-if="form.etapa_id === parseInt(value, 10)" color="success">
                    {{ desc }}
                  </v-badge>
                  <div v-else>{{ desc }}</div>
                </v-tab>
              </v-tabs>
            </v-toolbar>
          </template>
        </v-col>
      </v-row>
      <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
        <form
          @submit.prevent="handleSubmit(createOrUpdate)"
          v-if="loadPlano"
          :disabled="submittingForm"
        >
          <v-row>
            <v-col>
              <ValidationProvider name="Unidades Tematicas" rules="required" v-slot="{ errors }">
                <e-label>EIXOS TEMÁTICOS</e-label>
                <v-textarea solo dense v-model="form.unidades_tematicas" :error-messages="errors" />
              </ValidationProvider>

              <ValidationProvider
                name="Direitos de aprendizagem"
                rules="required"
                v-slot="{ errors }"
              >
                <e-label>DIREITOS DE APRENDIZAGEM E DESENVOLVIMENTO</e-label>

                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="3"
                    v-for="(item, index) in $constants.planoBimestralDireitosAprendizagem"
                    :key="index"
                  >
                    <v-checkbox
                      :label="item.label"
                      :value="item.label"
                      v-model="form.direitos_aprendizagem"
                      multiple
                      :error-messages="errors"
                    />
                  </v-col>
                </v-row>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider
                name="campos de experiência"
                rules="arrayNotEmpty"
                v-slot="{ errors }"
              >
                <label for=""> CAMPOS DE EXPERIÊNCIA </label>
                <v-card class="pa-md-4 mt-1">
                  <div>
                    <v-list>
                      <span class="error--text" v-if="errors.length">{{ errors[0] }}</span>
                      <v-divider class="theme--light"></v-divider>
                      <v-list-item
                        class="grey lighten-3 mb-3 pa-md-4"
                        v-for="m in experiencia"
                        :key="m"
                      >
                        <v-btn
                          @click="() => deletarExperiencia(m)"
                          class="mx-2"
                          fab
                          dark
                          small
                          color="red"
                        >
                          <v-icon dark> mdi-delete </v-icon>
                        </v-btn>
                        {{ m }}
                      </v-list-item>
                    </v-list>
                  </div>
                </v-card>
              </ValidationProvider>
            </v-col>

            <v-col cols="12">
              <v-dialog
                v-model="dialog"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mb-3 mt-5" color="blue" dark v-bind="attrs" v-on="on">
                    INSIRA O CÓDIGO
                  </v-btn>
                </template>

                <v-card>
                  <v-toolbar dark color="blue">
                    <v-btn icon dark @click="dialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>PESQUISA</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>

                  <v-col>
                    <v-row>
                      <v-col cols="12">
                        <v-sheet color="white" elevation="1">
                          <div class="py-2 px-4" color="white">
                            <v-text-field
                              @blur="search.length === 0 ? (objetivosAprendizagem = []) : false"
                              v-model="search"
                              autofocus
                              v-on:keyup="() => procurarHabilidade()"
                              label="DIGITE O CODIGO!"
                            ></v-text-field>
                          </div>
                        </v-sheet>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <v-sheet color="white" elevation="1" rounded>
                          <v-lazy>
                            <div class="text-start py-2 px-4 text-button blue white--text">
                              HABILIDADES ENCONTRADAS
                              <v-icon dark right> mdi-magnify </v-icon>
                            </div>
                          </v-lazy>
                          <v-divider class="theme--light"></v-divider>

                          <div class="py-2 px-4">
                            <v-skeleton-loader
                              v-if="carregandoHabilidades"
                              class="mx-auto"
                              max-width="auto"
                              type="list-item"
                            ></v-skeleton-loader>

                            <v-list-item
                              class="grey lighten-3 mb-3 pa-md-4"
                              v-for="m in objetivosAprendizagem"
                              :key="m.id"
                            >
                              <v-col cols="12" sm="10" class="d-flex flex-column justify-start">
                                [ {{ m.apelido }} ] {{ m.descricao }}
                                <v-row>
                                  <v-col>
                                    <v-chip class="mt-2" color="primary">
                                      {{ m.parent ? m.parent.descricao : "" }}
                                    </v-chip>
                                  </v-col>
                                </v-row>
                              </v-col>

                              <v-col cols="12" sm="2" align="center">
                                <v-btn
                                  @click="() => adicionarHabilidade(m)"
                                  class="mx-2"
                                  fab
                                  dark
                                  small
                                  color="blue"
                                >
                                  <v-icon dark> mdi-plus </v-icon>
                                </v-btn>
                              </v-col>
                            </v-list-item>
                          </div>
                        </v-sheet>
                      </v-col>
                      <v-col cols="6">
                        <v-sheet color="white" elevation="1">
                          <v-lazy>
                            <div class="text-start py-2 px-4 text-button blue white--text">
                              Habilidades selecionados
                              <v-icon dark right> mdi-checkbox-marked-circle </v-icon>
                            </div>
                          </v-lazy>

                          <v-divider class="theme--light"></v-divider>

                          <div class="py-2 px-4">
                            <p v-if="objeto_aprendizagem.length === 0">
                              Nenhuma habilidade selecionada
                            </p>
                            <ValidationProvider
                              name="objetivos de aprendizagem"
                              rules="arrayNotEmpty"
                              v-slot="{ errors }"
                            >
                              <span class="error--text" v-if="errors.length">{{ errors[0] }}</span>
                              <v-list-item
                                class="grey lighten-3 mb-3 pa-md-4"
                                v-for="(m, index) in objeto_aprendizagem"
                                :key="m.id"
                              >
                                <v-btn
                                  @click="() => deletarHabilidade(index, m)"
                                  class="mx-2"
                                  fab
                                  dark
                                  small
                                  color="red"
                                >
                                  <v-icon dark> mdi-delete </v-icon>
                                </v-btn>

                                <v-col cols="12" sm="10" class="d-flex flex-column justify-start">
                                  [ {{ m.apelido }} ] {{ m.descricao }}
                                  <v-row>
                                    <v-col>
                                      <v-chip class="mt-2" color="primary">
                                        {{ m.parent ? m.parent.descricao : "" }}
                                      </v-chip>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-list-item>
                            </ValidationProvider>
                          </div>
                        </v-sheet>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card>

                <v-snackbar v-model="showMessage" color="success">
                  <h4>{{ mensagem }}</h4>
                  <template v-slot:action="{ attrs }">
                    <v-btn color="white" text v-bind="attrs" @click="showMessage = false">
                      x
                    </v-btn>
                  </template>
                </v-snackbar>
              </v-dialog>

              <div></div>

              <label for=""> OBJETIVOS DE APRENDIZAGEM E DESENVOLVIMENTO </label>
              <v-card class="pa-md-4 mt-1">
                <div>
                  <v-list>
                    <v-divider class="theme--light"></v-divider>

                    <v-list-item
                      class="grey lighten-3 mb-3 pa-md-4"
                      v-for="(m, index) in objeto_aprendizagem"
                      :key="m.id"
                    >
                      <v-btn
                        @click="() => deletarHabilidade(index, m)"
                        class="mx-2"
                        fab
                        dark
                        small
                        color="red"
                      >
                        <v-icon dark> mdi-delete </v-icon>
                      </v-btn>
                      <v-col cols="12" sm="10" class="d-flex flex-column justify-start">
                        [ {{ m.apelido }} ] {{ m.descricao }}
                        <v-row>
                          <v-col>
                            <v-chip class="mt-2" color="primary">
                              {{ m.parent ? m.parent.descricao : "" }}
                            </v-chip>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <ValidationProvider
                name="ABORDAGENS E ESTRATÉGIAS DIDÁTICAS"
                rules="required"
                v-slot="{ errors }"
              >
                <e-label>ABORDAGENS E ESTRATÉGIAS DIDÁTICAS </e-label>
                <v-textarea
                  solo
                  dense
                  v-model="form.abordagens_estrategias_didaticas"
                  :error-messages="errors"
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12">
              <ValidationProvider name="RECURSOS" rules="required" v-slot="{ errors }">
                <e-label>RECURSOS (materiais e espaços)</e-label>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="3"
                    v-for="(item, index) in $constants.planoBimestralRecursos"
                    :key="index"
                  >
                    <v-checkbox
                      :label="item.label"
                      :value="item.label"
                      v-model="form.recursos"
                      multiple
                      :error-messages="errors"
                    />
                  </v-col>
                </v-row>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-col cols="12">
            <v-row>
              <v-btn
                color="primary"
                :disabled="submittingForm"
                :loading="submittingForm"
                type="submit"
              >
                Enviar Dados
              </v-btn>
              <v-btn
                color="success"
                class="ml-3"
                @click="exportDialog = true"
                :disabled="!planoPreenchido"
                >Exportar plano</v-btn
              >
            </v-row>
          </v-col>
        </form>
      </ValidationObserver>
      <v-row justify="center">
        <v-dialog v-model="exportDialog" persistent max-width="800px">
          <v-card>
            <v-card-title class="primary">
              <span style="color: #fff" class="text-h5">Exportar Plano</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-container>
                <ValidationObserver v-slot="{ handleSubmit }">
                  <form
                    v-if="show"
                    @submit.prevent="handleSubmit(exportarPlano)"
                    :disabled="submittingForm"
                  >
                    <v-row>
                      <v-col class="pt-4 pb-0" cols="12">
                        <e-label class="font-weight-medium">Turma</e-label>
                        <p class="font-weight-regular">
                          <v-select
                            :items="turmas"
                            item-text="turma.descricao"
                            item-value="turma.id"
                            return-object
                            label="Selecione o campo abaixo"
                            v-model="turmaSelecionada"
                            @change="(item) => setGestao(item)"
                          ></v-select>
                        </p>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <e-label class="font-weight-medium">EIXOS TEMÁTICOS</e-label>
                        <p class="font-weight-regular">
                          {{ form.unidades_tematicas }}
                        </p>
                      </v-col>
                      <v-col cols="12">
                        <e-label class="font-weight-medium"
                          >ABORDAGENS E ESTRATÉGIAS DIDÁTICAS
                        </e-label>
                        <p class="font-weight-regular">
                          {{ form.abordagens_estrategias_didaticas }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn style="color: #fff" class="red darken-1" @click="exportDialog = false">
                        Fechar
                      </v-btn>
                      <v-btn
                        :disabled="submittingForm"
                        :loading="submittingForm"
                        type="submit"
                        style="color: #fff"
                        class="green darken-1"
                        >Salvar</v-btn
                      >
                    </v-card-actions>
                  </form>
                </ValidationObserver>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>

      <e-drawer-planos-lancados
        v-model="openDrawer"
        :gestao_id="parseInt($route.params.gestaoDeAulaId, 10)"
        :disciplina_id="parseInt($route.params.disciplinaId, 10)"
        :etapa="etapaSelecionada"
      />
    </div>
  </main-template>
</template>

<script>
import { extend } from "vee-validate";
import ELabel from "../../components/ELabel.vue";

extend("arrayNotEmpty", {
  validate: (value) => Array.isArray(value) && value.length > 0,
  message: "É necessário selecionar pelo menos um item",
});

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    gestaoDeAulaId: {
      type: [String, Number],
      require: true,
    },
  },
  async mounted() {
    await this.loadData();
  },
  data() {
    return {
      habilidade: null,
      experiencia_: null,
      modalDeletarObjetivo: false,
      mensagem: "",
      carregandoHabilidades: false,
      showMessage: false,
      experiencia: [],
      objeto_aprendizagem: [],
      objetivosAprendizagem: [],
      dialog: false,
      search: "",
      submittingForm: false,
      form: {
        etapa_id: null,
        direitos_aprendizagem: [],
        recursos: [],
      },
      openDrawer: false,
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
      },
      loadPlano: true,
      etapas: [],
      tabIndexEtapas: null,
      exportDialog: false,
      show: true,
      turmas: [],
      turmaSelecionada: null,
      formExportarPlano: {
        etapa_id: null,
      },
    };
  },
  computed: {
    planoPreenchido() {
      return (
        this.form.unidades_tematicas &&
        this.form.unidades_tematicas.length > 0 &&
        this.form.abordagens_estrategias_didaticas &&
        this.form.abordagens_estrategias_didaticas.trim().length > 0 &&
        this.form.direitos_aprendizagem &&
        this.form.direitos_aprendizagem.length > 0 &&
        this.form.recursos &&
        this.form.recursos.length > 0
      );
    },
    turmaSemCircuito() {
      return this.etapas.length === 0;
    },
    etapaSelecionada() {
      const entry = Object.entries(this.etapas).find(([, val]) => val === this.form.etapa_id);
      if (!entry) return null;
      const [descricao, id] = entry;
      return { descricao, id };
    },
  },
  methods: {
    async deletarExperiencia(experiencia) {
      const pesquisa = experiencia.toString();
      const index = this.experiencia.findIndex((e) => e === pesquisa);
      this.experiencia.splice(index, 1);
      const habilidades = this.objeto_aprendizagem.filter((o) => o.parent.descricao !== pesquisa);
      this.objeto_aprendizagem = habilidades;
    },
    async deletarHabilidade(index, m) {
      const habilidadesExperiencias = this.objeto_aprendizagem.filter(
        (o) => o.parent.descricao === m.parent.descricao
      );
      if (habilidadesExperiencias.length === 1) {
        this.deletarExperiencia(m.parent.descricao);
      }
      this.objeto_aprendizagem.splice(index, 1);
      this.mensagem = "Habilidade deletada com sucesso!";
      this.showMessage = true;
    },
    async adicionarHabilidade(m) {
      const habilidade = this.objeto_aprendizagem.find((o) => o.id === m.id);
      if (habilidade) {
        this.mensagem = "Habilidade já selecionada!";
        this.showMessage = true;
        return;
      }
      this.objeto_aprendizagem.push(m);
      this.mensagem = "Habilidade adicionada com sucesso!";
      this.showMessage = true;

      this.adicionarExperiencia(m.parent.descricao);
    },
    async adicionarExperiencia(experiencia) {
      const experienciaJaExiste = this.experiencia.find((e) => e === experiencia);
      if (!experienciaJaExiste) this.experiencia.push(experiencia);
    },
    async procurarHabilidade() {
      this.carregandoHabilidades = true;
      const data = await this.$services.objetivosAprendizagem.pesquisar(
        this.search,
        this.$route.params.gestaoDeAulaId
      );
      this.objetivosAprendizagem = data.data.data;
      this.carregandoHabilidades = false;
    },
    async verHistoricoPlanos() {
      this.openDrawer = !this.openDrawer;
    },
    async createOrUpdate() {
      if (this.objeto_aprendizagem.length === 0) {
        this.$toast.danger("Selecione pelo menos um objetivo de aprendizagem");
        return;
      }

      if (this.experiencia.length === 0) {
        this.$toast.danger("Selecione pelo menos um campo de experiência");
        return;
      }
      this.$loaderService.open("Carregando dados...");
      try {
        const { gestaoDeAulaId } = this.$route.params;
        this.form.disciplina_id = this.gestaoDeAula.disciplina.id;
        this.form.instrutorDisciplinaTurma_id = gestaoDeAulaId;
        this.form.experiencia = this.experiencia.map((e) => e);
        this.form.objeto_aprendizagem = this.objeto_aprendizagem.map((o) => o.id);
        await this.$services.planosBimestraisInfantilService.createOrUpdate(this.form);
        this.$toast.success("Plano bimestral salvo com sucesso!");
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async loadData(etapa_id) {
      if (this.$refs.observer) {
        await this.$refs.observer.reset();
      }
      this.submittingForm = false;
      const { gestaoDeAulaId } = this.$route.params;
      try {
        this.$loaderService.open("Carregando dados...");
        if (etapa_id) {
          this.form.etapa_id = etapa_id;
        } else {
          this.gestaoDeAula = await this.$services.gestoesDeAulasService.visualizarTurmaGestao(
            gestaoDeAulaId
          );
          this.form.etapa_id = this.gestaoDeAula.turma.circuito?.etapas[0].id;
          const gestoes = await this.$services.gestoesDeAulasService.listarGestoesProfessor(
            this.gestaoDeAula
          );
          this.turmas = gestoes.filter((gestao) => gestao.turma.id !== this.gestaoDeAula.turma.id);
        }

        const response = await this.$services.planosBimestraisInfantilService.planoBimestral(
          gestaoDeAulaId,
          this.form.etapa_id
        );
        this.etapas = response.etapas ?? [];

        if (response.plano !== "") {
          this.preencherPlano(response);
        } else {
          this.limparPlano();
        }

        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    preencherPlano(response) {
      this.form = {
        ...response.plano,
        direitos_aprendizagem: response.plano.direitos_aprendizagem
          ? JSON.parse(response.plano.direitos_aprendizagem)
          : [],
        recursos: response.plano.recursos ? JSON.parse(response.plano.recursos) : [],
      };
      this.objeto_aprendizagem = response.habilidades;
      this.experiencia = response.plano.experiencia;
    },

    limparPlano() {
      this.form = {
        etapa_id: this.form.etapa_id,
        direitos_aprendizagem: [],
        recursos: [],
      };
      this.objeto_aprendizagem = [];
      this.experiencia = [];
    },
    async baixarDocumentoPlanoAnualInfantil() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.planosBimestraisService.baixarDocumentoPlanoAnualInfantil(
          parseInt(this.$route.params.gestaoDeAulaId, 10),
          parseInt(this.form.etapa_id, 10)
        );
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    setGestao(item) {
      this.export_gestao = item.id;
    },
    async exportarPlano() {
      this.$loaderService.open("Exportando plano...");
      try {
        const { bimestre } = this.form;

        this.formExportarPlano.instrutorDisciplinaTurma_id = this.export_gestao;
        this.formExportarPlano.disciplina_id = this.gestaoDeAula.disciplina.id;
        this.formExportarPlano.etapa_id = this.form.etapa_id;

        this.formExportarPlano.unidades_tematicas = this.form.unidades_tematicas;
        this.formExportarPlano.direitos_aprendizagem = this.form.direitos_aprendizagem;

        this.formExportarPlano.experiencia = this.experiencia.map((e) => e);
        this.formExportarPlano.objeto_aprendizagem = this.objeto_aprendizagem.map((o) => o.id);

        this.formExportarPlano.abordagens_estrategias_didaticas =
          this.form.abordagens_estrategias_didaticas;
        this.formExportarPlano.recursos = this.form.recursos;

        await this.$services.planosBimestraisInfantilService.createOrUpdate(this.formExportarPlano);

        this.$toast.success("Plano exportado com sucesso!");

        this.dialog = false;
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>

<style></style>
